import React, { useState } from 'react';
import { Bell, Settings, User, Search, Filter, Calendar } from 'lucide-react';
interface HeaderProps {
  onTimePeriodChange: (period: string) => void;
  currentPeriod: string;
}
export function Header({
  onTimePeriodChange,
  currentPeriod
}: HeaderProps) {
  const [showSearch, setShowSearch] = useState(false);
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="flex justify-between items-center h-16" data-id="element-198">
          {/* Left Section */}
          <div className="flex items-center space-x-4" data-id="element-199">
            <div data-id="element-200">
              <h1 className="text-xl font-bold text-gray-900" data-id="element-201">OptiSnow</h1>
              <p className="text-xs text-gray-500" data-id="element-202">
                Gestion intelligente d'opérations
              </p>
            </div>
            {/* Time Period Selector */}
            <select value={currentPeriod} onChange={e => onTimePeriodChange(e.target.value)} className="ml-4 px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-203">
              <option value="today" data-id="element-204">Aujourd'hui</option>
              <option value="week" data-id="element-205">Cette semaine</option>
              <option value="month" data-id="element-206">Ce mois</option>
              <option value="season" data-id="element-207">Cette saison</option>
            </select>
          </div>
          {/* Right Actions */}
          <div className="flex items-center space-x-2" data-id="element-208">
            {/* Search */}
            <div className="relative" data-id="element-209">
              {showSearch ? <input type="text" placeholder="Rechercher..." className="w-64 px-4 py-2 pl-10 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus onBlur={() => setShowSearch(false)} data-id="element-210" /> : <button onClick={() => setShowSearch(true)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-211">
                  <Search className="w-5 h-5" data-id="element-212" />
                </button>}
              {showSearch && <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-213" />}
            </div>
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-214">
              <Filter className="w-5 h-5" data-id="element-215" />
            </button>
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-lg relative" data-id="element-216">
              <Bell className="w-5 h-5" data-id="element-217" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" data-id="element-218"></span>
            </button>
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-lg" data-id="element-219">
              <Settings className="w-5 h-5" data-id="element-220" />
            </button>
            <button className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded-lg" data-id="element-221">
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-222">
                <User className="w-5 h-5 text-gray-600" data-id="element-223" />
              </div>
              <span className="text-sm font-medium text-gray-700" data-id="element-224">Admin</span>
            </button>
          </div>
        </div>
      </div>
    </header>;
}